export default __webpack_public_path__ + "static/media/ITD.3e324a89.pdf";